var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-row-user" }, [
    _c(
      "div",
      { staticClass: "dt-row-detail", class: { active: _vm.index % 2 == 1 } },
      [
        _c("div", {
          staticClass: "body-col",
          style: {
            width: _vm.columnWidth.firstName.size
              ? _vm.columnWidth.firstName.size + "px"
              : "10%"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "35%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.validator.name) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "45%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.validator.field) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.action.size
                ? _vm.columnWidth.action.size + "px"
                : "10%"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.editValidator()
                  }
                }
              },
              [
                _c(
                  "span",
                  [
                    _c("Icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true }
                        }
                      ],
                      staticClass: "icon",
                      attrs: { title: _vm.instructions.edit, name: "pencil" }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d0b9e456", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0b9e456","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalSettings/GlobalSettingsRow.vue
// module id = 2055
// module chunks = 1